import { voiceConfigSchema } from './config-schema.js';

export const voiceDefinition = {
  type: 'voice',
  nameKey: 'nodes.voice.name',
  subtitleKey: 'nodes.voice.subtitle',
  modalTitleKey: 'nodes.voice.title',
  icon: 'record_voice_over',
  color: '#EC4899',
  colorGradient: 'linear-gradient(135deg, #F472B6, #DB2777)',
  category: 'allApps',
  schema: voiceConfigSchema
};
